/*
 * skylit-gifts.js: window.SkylitGifts, the design x size-tier gift add-on
 * resolver. Data comes from snippets/skylit-gift-variants.liquid as
 * window.SKYLIT_GIFT_VARIANTS (rendered before this file loads). Kept as a
 * plain asset so tests/skylit-gifts.test.mjs can run it under node:vm.
 */
(function () {
  var SMALL_TIER = 'A4 / 30 x 40 cm';
  // REGULAR is what an unrecognised design string means (old cart lines, the
  // plain "Regular" option value). DESIGN_DEFAULT is what a new customer
  // starts on: Gold Dots since 2026-10-12, when Regular sold out. Regular
  // stays listed second, greyed out, while its variants are unavailable.
  var REGULAR = 'regular';
  var DESIGN_DEFAULT = 'dots';
  var DESIGN_ORDER = ['dots', 'regular', 'stripes', 'love', 'plaid', 'botanical'];
  var PAPER_TTL_MS = 30 * 86400000;

  // Ribbon colours offered on the ribbon / bundle add-ons. `name` is the
  // customer-facing label written to the "Ribbon Colour" cart property;
  // `slug` drives the per-colour preview overlay gift-ribbon-<slug>.png
  // hosted on agent.skylitstudio.co.uk (612x765, same geometry as the
  // legacy single red ribbon so it is a drop-in for every customiser).
  var RIBBON_BASE = 'https://agent.skylitstudio.co.uk/';
  var RIBBON_DEFAULT = 'Red';
  var RIBBON_COLORS = [
    { name: 'Red',         slug: 'red',         chip: '#b3261e' },
    { name: 'Gold',        slug: 'gold',        chip: '#c39c71' },
    { name: 'Pink',        slug: 'pink',        chip: '#d23c78' },
    { name: 'Evergreen',   slug: 'evergreen',   chip: '#1f5d44' },
    { name: 'Navy Blue',   slug: 'navy-blue',   chip: '#1d2b53' },
    { name: 'Baby Blue',   slug: 'baby-blue',   chip: '#a4c2dc' },
    { name: 'Pearl White', slug: 'pearl-white', chip: '#f0e9da' },
    { name: 'Black',       slug: 'black',       chip: '#1a1a1a' },
    // Printed satins: chip is a swatch image (ribbon-chip-<slug>.webp theme asset).
    { name: 'Gold Stars',      slug: 'gold-stars',      chip: '#8a4a22', printed: true },
    { name: 'Merry Christmas', slug: 'merry-christmas', chip: '#b3261e', printed: true }
  ];

  function ribbonMeta(anything) {
    var s = String(anything == null ? '' : anything).toLowerCase().replace(/[\s_]+/g, '-');
    for (var i = 0; i < RIBBON_COLORS.length; i++) {
      if (RIBBON_COLORS[i].slug === s || RIBBON_COLORS[i].name.toLowerCase() === s) return RIBBON_COLORS[i];
    }
    return RIBBON_COLORS[0];
  }
  function ribbonColorKey(anything) { return ribbonMeta(anything).name; }
  // orientation: 'portrait' (default, 612x765 bow) or 'landscape' (2048x1111 crop
  // used by the family moon, landscape location maps and Your Name From Orbit).
  function ribbonImageFor(anything, orientation) {
    var suffix = orientation === 'landscape' ? '-landscape' : '';
    return RIBBON_BASE + 'gift-ribbon-' + ribbonMeta(anything).slug + suffix + '.png';
  }

  function data() { return window.SKYLIT_GIFT_VARIANTS || {}; }
  function list(kind) { var d = data()[kind]; return Array.isArray(d) ? d : []; }

  function tierFor(sizeToken) {
    var s = String(sizeToken == null ? '' : sizeToken).toLowerCase().replace(/cm/g, '').replace(/\s/g, '');
    if (s === '40x50' || s === '50x40') return '40 x 50 cm';
    if (s === '50x70' || s === '70x50') return '50 x 70 cm';
    if (s === '60x80' || s === '80x60') return '60 x 80 cm';
    return SMALL_TIER;
  }

  function designKey(anything) {
    var s = String(anything == null ? '' : anything).toLowerCase();
    if (s.indexOf('plaid') !== -1 || s.indexOf('spruce') !== -1) return 'plaid';
    if (s.indexOf('botanical') !== -1 || s.indexOf('holly') !== -1) return 'botanical';
    if (s.indexOf('dot') !== -1) return 'dots';
    if (s.indexOf('stripe') !== -1) return 'stripes';
    if (s.indexOf('love') !== -1 || s.indexOf('heart') !== -1) return 'love';
    return REGULAR;
  }

  function designMeta(id) {
    var d = data().designs || {};
    return d[designKey(id)] || d[REGULAR] || { id: REGULAR, label: 'Regular', swatch: '', texture: '' };
  }

  function designs() {
    var offered = data().offered || [REGULAR];
    return offered
      .filter(function (id) { return DESIGN_ORDER.indexOf(id) !== -1; })
      .sort(function (a, b) { return DESIGN_ORDER.indexOf(a) - DESIGN_ORDER.indexOf(b); })
      .map(designMeta);
  }

  // Rows carry Shopify's variant.available. A sold-out variant is skipped so
  // nothing ever tries to add it (Shopify would refuse the whole add).
  // Rows without the flag (older cached HTML) count as available.
  function find(kind, tier, design, includeSoldOut) {
    var rows = list(kind);
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].design !== design || rows[i].tier !== tier) continue;
      if (rows[i].available === false && !includeSoldOut) continue;
      return rows[i];
    }
    return null;
  }

  // Sold out = the gift wrap product has variants for this design and none of
  // them can be bought. Shown greyed out in the pickers, never selectable.
  function soldOut(design) {
    var key = designKey(design);
    var rows = list('giftwrap'), seen = false;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].design !== key) continue;
      seen = true;
      if (rows[i].available !== false) return false;
    }
    return seen;
  }

  function entry(kind, sizeToken, design) {
    var d = data();
    if (kind === 'ribbon') return d.ribbon || null;
    if (kind !== 'giftwrap' && kind !== 'bundle') return null;
    var tier = tierFor(sizeToken);
    var want = designKey(design);
    // Preference order: exact design at the requested tier, then the
    // regular design at that same tier (a still-correct SIZE beats a
    // design match at the wrong size), then the exact design at the
    // small tier, then regular at the small tier.
    // Sold-out rows are skipped by find(), so a sold-out Regular falls
    // through to the default paper rather than a variant Shopify would refuse.
    var hit = find(kind, tier, want) || find(kind, tier, DESIGN_DEFAULT) || find(kind, tier, REGULAR) ||
      find(kind, SMALL_TIER, want) || find(kind, SMALL_TIER, DESIGN_DEFAULT) || find(kind, SMALL_TIER, REGULAR);
    if (hit && want !== DESIGN_DEFAULT && hit.design !== want) {
      try { console.warn('[SkylitGifts] no ' + want + ' variant for ' + kind + ' ' + tier + ', using ' + hit.design); } catch (e) {}
    }
    return hit;
  }

  // The paper a picker falls back to: Gold Dots, unless it is not offered or
  // sold out, then the first offered paper still for sale, then Regular.
  function pickDefault() {
    var ids = designs().map(function (d) { return d.id; });
    if (ids.indexOf(DESIGN_DEFAULT) !== -1 && !soldOut(DESIGN_DEFAULT)) return DESIGN_DEFAULT;
    for (var i = 0; i < ids.length; i++) if (!soldOut(ids[i])) return ids[i];
    return REGULAR;
  }

  // A design is offered at a size when the gift wrap product has a variant
  // for it at that tier (Love Hearts only comes in A4 and 40x50). Stock is a
  // separate question (soldOut); with no variant data loaded, nothing is hidden.
  function availableAt(design, sizeToken) {
    var key = designKey(design);
    if (key === REGULAR || key === DESIGN_DEFAULT || !list('giftwrap').length) return true;
    return !!find('giftwrap', tierFor(sizeToken), key, true);
  }

  // Hide customizer paper swatches the chosen size cannot have, and move a
  // selection off a hidden paper back to Regular (a click, so the
  // customizer's own onChange updates its state and preview). Cart-row
  // pickers (inside [data-cln]) are sized per line in Liquid and skipped.
  function syncPaperAvailability(sizeToken, root) {
    var pickers = (root || document).querySelectorAll('[data-gift-paper-picker]');
    for (var p = 0; p < pickers.length; p++) {
      var picker = pickers[p];
      if (picker.closest('[data-cln]')) continue;
      var buttons = picker.querySelectorAll('[data-gift-paper]');
      var shown = 0, fallback = null, current = picker.getAttribute('data-gift-paper-current');
      var fallbackId = pickDefault();
      for (var i = 0; i < buttons.length; i++) {
        var id = buttons[i].getAttribute('data-gift-paper');
        var ok = availableAt(id, sizeToken);
        buttons[i].hidden = !ok;
        if (ok) shown++;
        if (id === fallbackId) fallback = buttons[i];
      }
      picker.setAttribute('data-gpp-count', String(shown));
      if (current && (!availableAt(current, sizeToken) || soldOut(current)) && fallback) fallback.click();
    }
  }

  // The Gift wrap tooltip in every customizer shows giftwrap-framed.webp (the
  // Regular paper on a framed print). Papers with their own showcase clip
  // (designs[id].clip, e.g. giftwrap-dots.webp) swap it in while selected;
  // anything else restores the original. The Bundle clip is left alone.
  function syncPaperClips(design) {
    var clip = designMeta(design).clip || '';
    var imgs = document.querySelectorAll('img[data-gift-clip-default], img[src*="giftwrap-framed"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.hasAttribute('data-gift-clip-default')) img.setAttribute('data-gift-clip-default', img.getAttribute('src'));
      var want = clip || img.getAttribute('data-gift-clip-default');
      if (img.getAttribute('src') !== want) img.setAttribute('src', want);
    }
    // Inline clip card under the customizer paper swatches: the tooltip is
    // easy to miss on phones, this sits right where the paper was picked.
    var cards = document.querySelectorAll('[data-gpp-clip]');
    for (var c = 0; c < cards.length; c++) {
      var media = cards[c].querySelector('[data-gpp-clip-img]');
      var name = cards[c].querySelector('[data-gpp-clip-name]');
      if (clip) {
        if (media && media.getAttribute('src') !== clip) media.setAttribute('src', clip);
        if (name) name.textContent = designMeta(design).label;
        cards[c].hidden = false;
      } else {
        cards[c].hidden = true;
      }
    }
  }

  // Tap the inline clip to see it large. One shared <dialog>, built on first
  // use; the big clip only downloads then, with the small one shown while it
  // loads. Closes on the X, a tap anywhere, or Escape.
  var lightbox = null;
  function openClip(design) {
    var meta = designMeta(design);
    if (!meta.clip) return;
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'gpp-lightbox';
      lightbox.innerHTML = '<div class="gpp-lightbox-inner"><button type="button" class="gpp-lightbox-close" aria-label="Close">&times;</button>' +
        '<img class="gpp-lightbox-img" alt=""><span class="gpp-lightbox-name"></span></div>';
      lightbox.addEventListener('click', function () { lightbox.close(); });
      document.body.appendChild(lightbox);
    }
    var img = lightbox.querySelector('.gpp-lightbox-img');
    img.setAttribute('src', meta.clip);
    img.setAttribute('alt', meta.label + ' gift wrap paper');
    lightbox.querySelector('.gpp-lightbox-name').textContent = meta.label;
    if (meta.clipLarge) {
      var big = new Image();
      big.onload = function () { if (lightbox.open) img.setAttribute('src', meta.clipLarge); };
      big.src = meta.clipLarge;
    }
    if (typeof lightbox.showModal === 'function') lightbox.showModal(); else lightbox.setAttribute('open', '');
  }
  if (document.addEventListener) document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gpp-clip-open]');
    if (!btn) return;
    var picker = btn.closest('[data-gift-paper-picker]');
    openClip(picker && picker.getAttribute('data-gift-paper-current'));
  });

  function reverse(variantId) {
    var id = Number(variantId);
    var d = data();
    if (d.ribbon && Number(d.ribbon.id) === id) return { kind: 'ribbon', design: null };
    var kinds = ['giftwrap', 'bundle'];
    for (var k = 0; k < kinds.length; k++) {
      var rows = list(kinds[k]);
      for (var i = 0; i < rows.length; i++) {
        if (Number(rows[i].id) === id) return { kind: kinds[k], design: rows[i].design };
      }
    }
    return null;
  }

  // Remembered paper / ribbon choices, in localStorage for PAPER_TTL_MS.
  // GIFT_PAGE_KEY is what the gift wrap page (gift-wrap-page.js) saves under.
  var GIFT_PAGE_KEY = 'gift-page';
  function readPaper(key) {
    try {
      var raw = localStorage.getItem('skylit_paper_' + key);
      if (!raw) return null;
      var rec = JSON.parse(raw);
      if (!rec || (rec.ts && Date.now() - rec.ts > PAPER_TTL_MS)) { localStorage.removeItem('skylit_paper_' + key); return null; }
      return designKey(rec.design);
    } catch (e) { return null; }
  }
  function paperForSale(design) {
    var offeredIds = designs().map(function (d) { return d.id; });
    return offeredIds.indexOf(design) !== -1 && !soldOut(design);
  }
  function recallRibbon(key) {
    try {
      var raw = localStorage.getItem('skylit_ribbon_' + key);
      if (!raw) return null;
      var rec = JSON.parse(raw);
      if (!rec || (rec.ts && Date.now() - rec.ts > PAPER_TTL_MS)) { localStorage.removeItem('skylit_ribbon_' + key); return null; }
      return ribbonColorKey(rec.color);
    } catch (e) { return null; }
  }

  function formatPrice(pence) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var amount = (pence / 100).toFixed(2);
    return (cur === 'GBP' ? '£' : cur + ' ') + amount;
  }

  window.SkylitGifts = {
    SMALL_TIER: SMALL_TIER,
    DESIGN_DEFAULT: DESIGN_DEFAULT,
    tierFor: tierFor,
    designKey: designKey,
    designMeta: designMeta,
    designs: designs,
    labelFor: function (design) { return designMeta(design).label; },
    variantFor: function (kind, sizeToken, design) {
      var e = entry(kind, sizeToken, design);
      return e && e.id ? e.id : null;
    },
    priceFor: function (kind, sizeToken, design) {
      var e = entry(kind, sizeToken, design);
      return e && e.price ? e.price : 0;
    },
    availableAt: availableAt,
    soldOut: soldOut,
    pickDefault: pickDefault,
    syncPaperAvailability: syncPaperAvailability,
    syncPaperClips: syncPaperClips,
    openClip: openClip,
    designFor: function (variantId) { var r = reverse(variantId); return r ? r.design : null; },
    kindFor: function (variantId) { var r = reverse(variantId); return r ? r.kind : null; },
    formatPrice: formatPrice,
    refreshLabels: function (sizeToken, root) {
      var scope = root || document;
      var els = scope.querySelectorAll('[data-gift-price]');
      for (var i = 0; i < els.length; i++) {
        var pence = this.priceFor(els[i].getAttribute('data-gift-price'), sizeToken);
        if (!pence) continue;
        els[i].textContent = formatPrice(pence);
      }
      syncPaperAvailability(sizeToken, root);
    },
    /** Wire a rendered gift-paper-picker root. onChange(id) fires on click. Returns { set(id) }. */
    bindPaperPicker: function (rootEl, onChange) {
      if (!rootEl) return { set: function () {} };
      var buttons = rootEl.querySelectorAll('[data-gift-paper]');
      function set(id) {
        var key = designKey(id);
        for (var i = 0; i < buttons.length; i++) {
          var on = buttons[i].getAttribute('data-gift-paper') === key;
          buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        rootEl.setAttribute('data-gift-paper-current', key);
        if (!rootEl.closest('[data-cln]')) syncPaperClips(key);
      }
      if (rootEl.getAttribute('data-gift-paper-bound') !== '1') {
        rootEl.setAttribute('data-gift-paper-bound', '1');
        for (var i = 0; i < buttons.length; i++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              var id = btn.getAttribute('data-gift-paper');
              set(id);
              if (onChange) onChange(id);
            });
          })(buttons[i]);
        }
      }
      return { set: set };
    },
    applyPaperTexture: function (imgEl, design) {
      if (!imgEl) return;
      var src = designMeta(design).texture;
      if (src && imgEl.getAttribute('src') !== src) imgEl.setAttribute('src', src);
    },
    RIBBON_DEFAULT: RIBBON_DEFAULT,
    ribbonColors: function () { return RIBBON_COLORS.slice(); },
    ribbonColorKey: ribbonColorKey,
    ribbonImageFor: ribbonImageFor,
    /** Wire a rendered gift-ribbon-picker root. onChange(name) fires on click. Returns { set(name) }. */
    bindRibbonPicker: function (rootEl, onChange) {
      if (!rootEl) return { set: function () {} };
      var buttons = rootEl.querySelectorAll('[data-gift-ribbon]');
      function set(name) {
        var key = ribbonColorKey(name);
        for (var i = 0; i < buttons.length; i++) {
          var on = buttons[i].getAttribute('data-gift-ribbon') === key;
          buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        rootEl.setAttribute('data-gift-ribbon-current', key);
      }
      if (rootEl.getAttribute('data-gift-ribbon-bound') !== '1') {
        rootEl.setAttribute('data-gift-ribbon-bound', '1');
        for (var i = 0; i < buttons.length; i++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              var name = ribbonColorKey(btn.getAttribute('data-gift-ribbon'));
              set(name);
              if (onChange) onChange(name);
            });
          })(buttons[i]);
        }
      }
      return { set: set };
    },
    rememberRibbon: function (key, name) {
      try { localStorage.setItem('skylit_ribbon_' + key, JSON.stringify({ color: ribbonColorKey(name), ts: Date.now() })); } catch (e) {}
    },
    recallRibbon: recallRibbon,
    // A design's own ribbon colour, else the one picked on the gift wrap
    // page (GIFT_PAGE_KEY). Only the colour carries over, never the wrapping.
    recallRibbonFor: function (key) {
      return (key && recallRibbon(key)) || recallRibbon(GIFT_PAGE_KEY);
    },
    rememberPaper: function (key, design) {
      try { localStorage.setItem('skylit_paper_' + key, JSON.stringify({ design: designKey(design), ts: Date.now() })); } catch (e) {}
    },
    recallPaper: function (key) {
      var recalled = readPaper(key);
      if (!recalled) return null;
      return paperForSale(recalled) ? recalled : pickDefault();
    },
    // A design's own paper (recallPaper, clamped as before), else the paper
    // picked on the gift wrap page. The gift page's paper is only a
    // preselect: one no longer offered, sold out or not made at sizeToken
    // (when given) returns null, so the customiser keeps its normal default.
    recallPaperFor: function (key, sizeToken) {
      var own = key ? this.recallPaper(key) : null;
      if (own) return own;
      var fromPage = readPaper(GIFT_PAGE_KEY);
      if (!fromPage || !paperForSale(fromPage)) return null;
      if (sizeToken && !availableAt(fromPage, sizeToken)) return null;
      return fromPage;
    }
  };
})();
